import * as React from "react";
import { Button, Link, Modal, Toast } from "react-ui";

import { IForm } from "../../../../Engine/Form/IForm";
import { setFakeErrorLogForDraft } from "../../../../Engine/Fakes/FakeErrorLog";
import {
    IErrorLogTaskResult,
    InterdocumentCheckStatus,
    InterdocumentCheckType,
} from "../../../../Engine/Core/ErrorManager/Utils/Models";

import { MonospaceTextarea } from "./FakeErrorLogSetter.styles";

interface FakeErrorLogsSetterProps {
    onClose: () => void;
    onErrorCheck: () => void;
    form: IForm;
}

const errorLogExample1: ServerErrorLog = {
    errors: [
        {
            id: "1",
            description: "Ошибка в checkbox",
            path: "/Root/1/Checkbox/1/CheckboxValue",
            source: "/Корень (Файл)/Страница 1/Типа чекбокс (@НашЧекБокс)",
            tags: null,
            usedArguments: [],
        },
    ],
    warnings: [],
    successes: [],
};
const errorLogExample2: IErrorLogTaskResult = {
    errorLogName: "srv/forms/1",
    propsName: "srv/forms/2",
    hasErrors: true,
    canSend: false,
    mainReportCheckLog: {
        errorLogName: null,
        propsName: null,
        errors: [],
        warnings: [],
        successes: [],
    },
    mainReportCrossCheckLog: {
        errorLogName: null,
        propsName: null,
        errors: [
            {
                id: "1",
                description: "Фейковая ошибка",
                path: null,
                source: "Реквизиты плательщика/Код ИФНС",
                tags: null,
                justification: null,
                usedArguments: [],
            },
        ],
        warnings: [],
        successes: [],
    },
    warrantCheckLog: {
        errorLogName: null,
        propsName: null,
        errors: [
            {
                id: "1",
                description: "Фейковая ошибка warrantCheckLog",
                path: null,
                source: "Реквизиты плательщика/Код ИФНС",
                tags: null,
                justification: null,
                usedArguments: [],
            },
        ],
        warnings: [],
        successes: [],
    },
    digitalWarrantCheckLog: {
        errorLogName: null,
        propsName: null,
        errors: [
            {
                id: "1",
                description: "Фейковая ошибка digitalWarrantCheckLog",
                path: null,
                source: "Реквизиты плательщика/Код ИФНС",
                tags: null,
                justification: null,
                usedArguments: [],
            },
        ],
        warnings: [],
        successes: [],
    },
    attachmentsCheckLogsWithIds: {},
    interdocumentsCheckLog: {
        status: InterdocumentCheckStatus.Success,
        checks: [
            {
                type: InterdocumentCheckType.Fine,
                title: "Нет расхождений с отчетом",
                checkedReports: [
                    {
                        caption: "НДС за IV кв. 2022",
                        url: "/some/path",
                        id: "2",
                    },
                ],
                discrepancyInfo: null,
            },
        ],
    },
};

export function FakeErrorLogsSetter(props: FakeErrorLogsSetterProps): JSX.Element {
    const [errorLogString, setErrorLogString] = React.useState("");

    const handleSetErrorLog = () => {
        try {
            const errorLog = eval(`(${errorLogString})`);
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
            setFakeErrorLogForDraft(props.form.settings.draftId, errorLog);
            Toast.push("Протокол контроля установлен.", { label: "Запустить проверку", handler: props.onErrorCheck });
            props.onClose();
        } catch {
            Toast.push("Не удалось установить протокол контроля. Проверьте корректность введеного лога.");
        }
    };

    const handleSetExample1 = () => {
        setErrorLogString(JSON.stringify(errorLogExample1, undefined, 4));
    };
    const handleSetExample2 = () => {
        setErrorLogString(JSON.stringify(errorLogExample2, undefined, 4));
    };

    return (
        <Modal ignoreBackgroundClick onClose={props.onClose}>
            <Modal.Header>Установить фековый протокол контроля</Modal.Header>
            <Modal.Body>
                <MonospaceTextarea rows={15} value={errorLogString} onChange={e => setErrorLogString(e.target.value)} />
                <div>
                    <Link onClick={handleSetExample1}>Пример #1 (простой)</Link>
                </div>
                <div>
                    <Link onClick={handleSetExample2}>Пример #2 (расширенный)</Link>
                </div>
            </Modal.Body>
            <Modal.Footer panel>
                <Button use="primary" onClick={handleSetErrorLog}>
                    Установить
                </Button>
                <span style={{ display: "inline-block", width: 12 }} />
                <Button onClick={props.onClose}>Отменить</Button>
            </Modal.Footer>
        </Modal>
    );
}
